module.exports = __webpack_public_path__ + "img/rxr.74da6227.png";